import React from 'react';

import Accordion from '../accordion/accordion.component';
import CustomRadioSelect from '../custom-radio-select/custom-radio-select.component';

import { uniqueId } from '../../utilities';

const defaultProps = {
  options: ['Last Year', 'Normal'],
  value: 'Last Year',
  label: (value) => `Departure From ${value}`,
  title: 'Compare Today To',
  id: uniqueId()
};

export default function RadioSelector({
  expanded,
  handleChange,
  handleChangeSelection,
  value=defaultProps.value,
  options=defaultProps.options,
  label=defaultProps.label,
  title=defaultProps.title,
  id=defaultProps.id
}) {
  return (
    <Accordion expanded={expanded === id} handleChange={handleChange} id={id} label={label(value)} >
      <CustomRadioSelect
        title={title}
        value={value}
        changeFunction={handleChangeSelection}
        options={options}
      />
    </Accordion>
  );
}

export { defaultProps };